import { EOtpChannelTypes, EOtpTemplateChannelTypes } from '@sigmasms/shared-types'

import { services } from '@/utils'

export const getChannelTypes = service => {
  switch (service) {
    case services['otp-settings/channels']: return Object.values(EOtpChannelTypes)
    case services['otp-settings/templates']: return Object.values(EOtpTemplateChannelTypes)
  }
}
